<div
  #jitsiContainer
  class="w-full h-screen bg-black">
</div>
